export const maskPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return phoneNumber;
  return phoneNumber.replace(/(\d{3})\d{4}(\d{4})/g, '$1****$2');
};

export const getLastMonthTimeRange = () => {
  // 获取当前日期
  const currentDate = new Date();

  // 设置开始日期为当前日期的前一个月
  const startDate = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() - 1,
    currentDate.getDate()
  );

  // 设置结束日期为当前日期
  const endDate = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    currentDate.getDate()
  );

  // 格式化日期为 'YYYY-MM-DD HH:MM:SS' 格式
  function formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  // 输出时间范围
  return [formatDate(startDate), formatDate(endDate)];
};

// // 示例调用
// const timeRange = getLastMonthTimeRange();
// console.log(timeRange);
